import UserActions from "../Types";

const initialState = {
  isGettingTestLogs: false,
  testLogsSuccess: false,
  testLogs: [],
  isRunningTests: false,
  testSuccess: false,
  testResults: {},
  submissionStatus: false,
  isSubmittingTests: false,
  tests: {},
  submitAgreementStatus: false,
  isSubmittingAgreement: false,
  agreement: {},
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UserActions.GET_TESTCASE_LOGS_START:
      return {
        ...state,
        isGettingTestLogs: true,
        testLogsSuccess: false,
        error: null,
      };
    case UserActions.GET_TESTCASE_LOGS_SUCCESS:
      return {
        ...state,
        isGettingTestLogs: false,
        testLogsSuccess: true,
        testLogs: action.payload,
        error: null,
      };
    case UserActions.GET_TESTCASE_LOGS_FAILURE:
      return {
        ...state,
        isGettingTestLogs: false,
        testLogsSuccess: false,
        error: action.payload,
      };
    case UserActions.RUN_TEST_START:
      return {
        ...state,
        isRunningTests: true,
        testSuccess: false,
        error: null,
      };
    case UserActions.RUN_TEST_SUCCESS:
      return {
        ...state,
        isRunningTests: false,
        testSuccess: true,
        testResults: action.payload,
        error: null,
      };
    case UserActions.RUN_TEST_FAILURE:
      return {
        ...state,
        isRunningTests: false,
        testSuccess: false,
        error: action.payload,
      };
    case UserActions.SUBMIT_TEST_RESULTS_START:
      return {
        ...state,
        isSubmittingTests: true,
        submissionStatus: false,
        error: null,
      };
    case UserActions.SUBMIT_TEST_RESULTS_SUCCESS:
      return {
        ...state,
        isSubmittingTests: false,
        submissionStatus: true,
        tests: action.payload,
        error: null,
      };
    case UserActions.SUBMIT_TEST_RESULTS_FAILURE:
      return {
        ...state,
        isSubmittingTests: false,
        submissionStatus: false,
        error: action.payload,
      };
    case UserActions.SUBMIT_AGREEMENT_START:
      return {
        ...state,
        isSubmittingAgreement: true,
        submitAgreementStatus: false,
        error: null,
      };
    case UserActions.SUBMIT_AGREEMENT_SUCCESS:
      return {
        ...state,
        isSubmittingAgreement: false,
        submitAgreementStatus: true,
        agreement: action.payload,
        error: null,
      };
    case UserActions.SUBMIT_AGREEMENT_FAILURE:
      return {
        ...state,
        isSubmittingAgreement: false,
        submitAgreementStatus: false,
        error: action.payload,
      };
    case UserActions.RESET_SUBMIT_AGREEMENT_STATUS:
      return {
        ...state,
        submitAgreementStatus: false,
      };
    case UserActions.CLEAR_CHECK_STATUS:
      return {
        ...state,
        isSubmittingAgreement: false,
        submitAgreementStatus: false,
      };
    default:
      return state;
  }
};
